<gl-pro-modal (closeModal)="close('close')">
  <p>
    <span class="user">{{ 'user' | translate }} </span>{{lastUser}} {{ 'user_has_made_changes' | translate}}
  </p>
  <div class="buttons center">
    <button outline-button (click)="viewChanges()">{{ 'view_changes' | translate }}</button>
    <button outline-button (click)="saveChanges()">{{ 'save_changes' | translate }}</button>
  </div>
</gl-pro-modal>
